import clsx from "clsx";
import "./styles.scss";

interface IFlightCalendarDateLabelProps {
  value: string;
  index: number;
}

export const PriceRangeTag = ({
  value,
  index,
}: IFlightCalendarDateLabelProps) => {
  return (
    <div className="price-range-tag">
      <div
        className={clsx("price-tag-container", `price-index-${index}`)}
      ></div>
      <p className="price-tag-text">{value}</p>
    </div>
  );
};
